import { DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import {
  buildFirestoreDocument,
  createDoc,
  getCollectionDocs,
  getDocOrThrow,
  QueryCollectionOptions,
} from '../utils/firestore.utils';
import { FirestoreDocument } from '../../shared/models/firestore-document';
import { JobPosting } from '../../models/job-posting/job-posting.model';
import { getJobPostingRef, getJobPostingsCol } from '../refs/job-posting.refs';
import { Organization } from '../../models/organization/organization.model';

export async function createJobPosting(
  parentRef: DocumentReference<Organization>,
  data: JobPosting
): Promise<FirestoreDocument<JobPosting>> {
  const col = getJobPostingsCol(parentRef);
  const ref = await createDoc(col, data);
  return buildFirestoreDocument(ref, data);
}

export function getJobPosting(
  parentRef: DocumentReference<Organization>,
  jobPostingId: string
): Observable<FirestoreDocument<JobPosting>> {
  const ref = getJobPostingRef(parentRef, jobPostingId);
  return getDocOrThrow(ref);
}

export function getJobPostings<K extends keyof JobPosting>(
  parentRef: DocumentReference<Organization>,
  options?: QueryCollectionOptions<JobPosting, K>
): Observable<FirestoreDocument<JobPosting>[]> {
  const col = getJobPostingsCol(parentRef);
  return getCollectionDocs(col, options);
}
